import react, { useEffect, useState } from 'react';
import useAxios from '../../Hooks/use-axios';
import { getConfig } from '../../utils/config';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../store/auth-slice';
import { useLocation } from 'react-router-dom';

const useData = (isRewards) => {
    const [rewards, setrewards] = useState([]);
    const [isRewardsLoaded, setIsRewardsLoaded] = useState(false);
    const location = useLocation();
    const [rewardsCategoryList, setRewardsCategoryList] = useState([]);
    // const [selectedRewardCategory, setSelectedRewardCategory] = useState(null);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const isRewardRefreshing = useSelector(
        (state) => state.deals.isRefreshRewards
    );
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    // console.log('USER REWARD POINTS STORE', totalRewardspoint);
    const queryParams = new URLSearchParams(location.search);

    const dispatch = useDispatch();
    const config = getConfig();

    const { isLoading: isLoadingrewards, sendRequest: fetchrewards } =
        useAxios();
    const {
        isLoading: isLoadingRewardsCategory,
        sendRequest: fetchRewardsCategory
    } = useAxios();

    const getRewards = () => {
        if (isRewards) {
            fetchrewards(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url: `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=100&rewardsPage=true`,
                    method: 'get',
                    isFormData: true
                },
                (res) => {
                    console.log('rewards from data', res?.content);

                    if (res?.status == 'FAILED') {
                        setrewards([]);
                        return;
                    }
                    setrewards(res?.content);
                    setIsRewardsLoaded(true);
                }
            );
        }
    };

    const getRewardCategories = () => {
        let url;
        if (isAuthenticated) {
            url = `winnre/user/reward-categories/getAllByFilter?`;
        } else {
            url = `cms_service/reward-categories/getAllByFilter?clientId=${config?.id}$`;
        }
        const method = 'get';
        url = url + 'pageSize=100';

        fetchRewardsCategory(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url,
                method,
                isFormData: true
            },
            (data) => {
                console.log('Rewards Category', data?.content);
                if (data?.status == 'FAILED') {
                    setRewardsCategoryList([]);
                    return;
                }
                setRewardsCategoryList(data?.content);
            }
        );
    };

    useEffect(() => {
        if (isRewards && isAuthenticated) {
            getRewardCategories();
        }
    }, [isAuthenticated, isRewards]);

    useEffect(() => {
        getRewards();
    }, [
        isRewards,
        isAuthenticated,
    ]);

    return {
        rewards,
        isLoadingrewards,
        getRewards,
        isRewardsLoaded,
        totalRewardspoint,
        rewardsCategoryList,
        // selectedRewardCategory,
        // setSelectedRewardCategory
    };
};

export default useData;
